import React from 'react'
import './Card.scss'

interface CardProps {
  image: string
  name: string
  text: string
  link: string
  cursor: any
  cursorText: any
}

function Card({ image, name, text, link, cursor, cursorText }: CardProps) {
  const onMouseEnter = () => {
    cursor.current.style.height = '9rem'
    cursor.current.style.width = '9rem'
    cursorText.current.style.opacity = 1
  }

  const onMouseLeave = () => {
    cursor.current.style.height = '2rem'
    cursor.current.style.width = '2rem'
    cursorText.current.style.opacity = 0
  }

  return (
    <a
      className='card'
      href={link}
      target='_blank'
      rel='noopener noreferrer'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <div className='card__content'>
        <h5>{name}</h5>
        <h3>{text}</h3>
      </div>
      <div className='card__image'>
        <img src={image} alt={name} />
      </div>
    </a>
  )
}

export default Card
